import React from "react";
import styled from "styled-components";

type ListSectionProps = {
  title: string;
  children: React.ReactNode;
};

export const ListSection = ({ title, children }: ListSectionProps) => {
  return (
    <StyledListSection>
      <p className="title">{title}</p>
      <div className="content">{children}</div>
    </StyledListSection>
  );
};

const StyledListSection = styled.section`
  width: 100%;
  height: max-content;
  padding: 1.2rem 0;
  display: flex;
  flex-flow: column nowrap;
  gap: 0.4rem;
  & > .title {
    font: var(--body-medium-600);
    color: var(--text-gray-8);
    padding: 0.4rem;
    margin-bottom: 0.4rem;
    border-bottom: 0.1rem solid var(--text-gray-3);
  }
  & > .content {
    margin: 0 2rem;
    display: flex;
    flex-flow: column nowrap;
    gap: 1.8rem;
  }
`;
